import React, { FC } from 'react';
import { Link } from '../../../components/Link';
import Arrow from '../../../components/Arrow';
import styles from './AIToolCard.module.scss';

interface Props {
  /** 工具名称 */
  title: string;
  /** 工具描述 */
  description: string;
  /** 链接地址 */
  linkUrl?: string;
  /** 是否外部链接 */
  linkOut?: boolean;
  /** 查看详情按钮文本 */
  linkText?: string;
}

/**
 * AI工具卡片组件
 * 用于展示AI工具信息，支持hover效果和查看详情按钮
 */
const AIToolCard: FC<Props> = (props) => {
  const { title, description, linkUrl = '', linkOut = false, linkText = '查看详情' } = props;

  const cardContent = (
    <>
      <div className={styles['card-header']}>
        <h3 className={styles['card-title']}>{title}</h3>
        {linkUrl && (
          <div className={styles['card-action']}>
            <span className={styles['action-text']}>{linkText}</span>
            <Arrow className={styles['action-arrow']} />
          </div>
        )}
      </div>
      <div className={styles['card-description']}>{description}</div>
    </>
  );

  if (linkUrl) {
    return (
      <Link
        href={linkUrl}
        className={styles['ai-tool-card']}
        target={linkOut ? '_blank' : '_self'}
        rel={linkOut ? 'noopener noreferrer' : undefined}
        scroll={false}
        prefetch={false}
      >
        {cardContent}
      </Link>
    );
  }

  return <div className={styles['ai-tool-card']}>{cardContent}</div>;
};

AIToolCard.displayName = 'AIToolCard';
export default AIToolCard;
